import { useCallback, useEffect, useRef, useState } from "react";
import type { ToastMessage } from "../components/ToastRegion";

export function useToasts() {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);
  const timers = useRef<number[]>([]);

  useEffect(() => () => timers.current.forEach(window.clearTimeout), []);

  const dismissToast = useCallback((id: string) => {
    setToasts((current) => current.filter((toast) => toast.id !== id));
  }, []);

  const addToast = useCallback((message: string, tone: ToastMessage["tone"] = "info") => {
    const id = `${Date.now()}-${Math.random()}`;
    setToasts((current) => [...current, { id, message, tone }]);
    timers.current.push(window.setTimeout(() => dismissToast(id), 5000));
  }, [dismissToast]);

  return { toasts, addToast, dismissToast };
}
